import { createContext, useContext } from 'react';

export interface AppShellContextValue {
  /** Desktop icon-rail state (persisted). */
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
  /** True at >= 1024px; below that the navigation is an off-canvas drawer. */
  isDesktop: boolean;
  mobileNavOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
  /** Collapses/expands on desktop, opens/closes the drawer on smaller screens. */
  toggleNav: () => void;
  /** id of the navigation container (for aria-controls). */
  navId: string;
}

export const AppShellContext = createContext<AppShellContextValue | null>(null);

/** Shell state for custom navigation controls. Returns null outside <AppShell>. */
export function useAppShell(): AppShellContextValue | null {
  return useContext(AppShellContext);
}

export const SIDENAV_COLLAPSED_STORAGE_KEY = 'intellschools.sidenav.collapsed';
export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
